var map = {
	"./1.jpg": "M18e",
	"./10.jpg": "zybH",
	"./2.jpg": "WcjD",
	"./3.jpg": "NMA0",
	"./4.jpg": "OrZJ",
	"./5.jpg": "EbuL",
	"./6.jpg": "Qm9v",
	"./7.jpg": "3R3b",
	"./8.jpg": "oSR6",
	"./9.jpg": "XzzB"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8Wbs";